module.exports = __webpack_public_path__ + "img/video-call2.c3328074.svg";